// extracted by mini-css-extract-plugin
export default {"messageContainer":"message_messageContainer__XMaJl","messageCard":"message_messageCard__SiGrd"};